import { createSlice } from "@reduxjs/toolkit";

/**
 * @type {BD_StorePageWaitingRoom}
 */
const initialState = {
  avatarOptions: [],
  isUploadedAvatar: false,
  uploadedAvatar: undefined,
  selectedAvatar: undefined,
};

const pageWaitingRoomSlice = createSlice({
  name: "pageWaitingRoom",
  initialState,
  reducers: {
    /**
     * @param {typeof initialState} state
     * @param {import("@reduxjs/toolkit").PayloadAction<typeof initialState['avatarOptions']>} action
     */
    setAvatarOptions: (state, action) => ({
      ...state,
      avatarOptions: action.payload,
      selectedAvatar: state.selectedAvatar ?? action.payload[0].value,
    }),

    /**
     * @param {typeof initialState} state
     * @param {import("@reduxjs/toolkit").PayloadAction<typeof initialState['uploadedAvatar']>} action
     */
    uploadAvatar: (state, action) => ({
      ...state,
      isUploadedAvatar: true,
      uploadedAvatar: action.payload,
      selectedAvatar: undefined,
    }),

    /**
     * @param {typeof initialState} state
     * @param {import("@reduxjs/toolkit").PayloadAction<typeof initialState['selectedAvatar']>} action
     */
    setSelectedAvatar: (state, action) => ({
      ...state,
      isUploadedAvatar: false,
      uploadedAvatar: undefined,
      selectedAvatar: action.payload,
    }),
  },
});

export const { setAvatarOptions, uploadAvatar, setSelectedAvatar } =
  pageWaitingRoomSlice.actions;
export const pageWaitingRoom = pageWaitingRoomSlice.reducer;
